import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-plus-icon',
  templateUrl: './plus-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlusIconComponent {
  @Input() public color: string = '#0064be';
}
